import { Enrollment } from '../../lib/types/models/enrollment/enrollment'
import {
  EnrollmentInput,
  EnrollmentRequest
} from '../../lib/types/models/enrollment/enrollment-input'
import { API, constructApiUrl } from '../apis.config'
import { uploadFileSecurely, UploadPurpose } from '../media/secure-upload'
import { restApiClient } from '../rest-api-client'

export async function createEnrollment(data: EnrollmentInput) {
  const { secureIdentityPicture, familyImages: secureFamilyImages, ...rest } = data

  let identityPicture = undefined
  let familyImages = undefined

  if (secureIdentityPicture?.file) {
    const uploadId = await uploadFileSecurely({
      file: secureIdentityPicture.file,
      purpose: UploadPurpose.ENROLLMENT_PICTURE
    })
    identityPicture = { uploadId, caption: secureIdentityPicture.caption }
  }

  if (secureFamilyImages) {
    familyImages = []
    for (const fileImage of secureFamilyImages) {
      if (fileImage.file) {
        const uploadId = await uploadFileSecurely({
          file: fileImage.file,
          purpose: UploadPurpose.ENROLLMENT_FAMILY_IMAGE
        })
        familyImages.push({ uploadId, caption: fileImage.caption })
      }
    }
  }

  return restApiClient
    .url(constructApiUrl(API.enrollments.create.url, null))
    .post<Enrollment, EnrollmentRequest>({ ...rest, identityPicture, familyImages })
}
